module.exports = __webpack_public_path__ + "f110e472a92fb698cd4e696d45ac5010.png";